import React, { useState, useEffect } from 'react';
import { Toaster, toast } from 'react-hot-toast';
import TweetLibrary from './pages/TweetLibrary';
import SchedulePage from './pages/SchedulePage';
import AiGeneratePage from './pages/AiGeneratePage';
import SettingsPage from './pages/SettingsPage';
import HistoryPage from './pages/HistoryPage';
import LoginScreen from './components/LoginScreen';
import { loginAPI } from './api';
import './App.css';

const NAV_ITEMS = [
  { id: 'library', label: 'ツイートライブラリ', icon: '📚' },
  { id: 'schedule', label: 'スケジュール', icon: '🗓️' },
  { id: 'ai', label: 'AI生成', icon: '🤖' },
  { id: 'history', label: '投稿履歴', icon: '📊' },
  { id: 'settings', label: '設定', icon: '⚙️' },
];

function App() {
  const [activePage, setActivePage] = useState('library');
  const [user, setUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);

  // 初期: 認証状態確認
  useEffect(() => {
    loginAPI.me()
      .then(r => { if (r.data.authenticated) setUser(r.data.user); })
      .catch(() => {})
      .finally(() => setAuthChecked(true));
    // login=ok の query をトースト表示
    const q = new URLSearchParams(window.location.search);
    if (q.get('login') === 'ok') {
      setTimeout(() => toast.success('ログインしました ✨'), 100);
      window.history.replaceState({}, '', window.location.pathname);
    }
    // 401 検知でログアウト
    const onUnauth = () => setUser(null);
    window.addEventListener('xap:unauthorized', onUnauth);
    return () => window.removeEventListener('xap:unauthorized', onUnauth);
  }, []);

  const logout = async () => {
    try { await loginAPI.logout(); } catch {}
    setUser(null);
    toast.success('ログアウトしました');
  };

  if (!authChecked) {
    return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0a0a0f', color: '#fff' }}>読み込み中…</div>;
  }
  if (!user) {
    return <LoginScreen />;
  }

  const renderPage = () => {
    switch (activePage) {
      case 'library': return <TweetLibrary onSchedule={() => setActivePage('schedule')} />;
      case 'schedule': return <SchedulePage />;
      case 'ai': return <AiGeneratePage onSaved={() => setActivePage('library')} />;
      case 'history': return <HistoryPage />;
      case 'settings': return <SettingsPage />;
      default: return <TweetLibrary />;
    }
  };

  return (
    <div className="app">
      <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
      <nav className="sidebar">
        <div className="sidebar-header">
          <div className="logo">𝕏 AutoPost</div>
          <div className="logo-sub">自動投稿ツール</div>
        </div>
        <ul className="nav-list">
          {NAV_ITEMS.map(item => (
            <li
              key={item.id}
              className={`nav-item ${activePage === item.id ? 'active' : ''}`}
              onClick={() => setActivePage(item.id)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span>{item.label}</span>
            </li>
          ))}
        </ul>
        <div className="sidebar-footer">
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.7)', marginBottom: 6, wordBreak: 'break-all' }}>
            👤 {user.email}
          </div>
          <button
            onClick={logout}
            style={{ width: '100%', padding: '6px 8px', background: 'rgba(255,255,255,0.1)', color: '#fff', border: '1px solid rgba(255,255,255,0.2)', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}
          >ログアウト</button>
          <div className="footer-text" style={{ marginTop: 8 }}>株式会社ネクストビズ</div>
        </div>
      </nav>
      <main className="main-content">
        {renderPage()}
      </main>
    </div>
  );
}

export default App;
